export const MODAL_DIALOG_ANIMATION_DURATION: number = 400;